/** Strip non-digits; Supabase email OTP is 6 numeric digits. */
export function normalizeEmailOtp(raw: string): string {
  return raw.replace(/\D/g, '').slice(0, 6);
}

export function isValidEmailOtp(raw: string): boolean {
  return raw.replace(/\D/g, '').length === 6;
}

/** Ask the browser to keep auth storage (helps installed PWAs on some platforms). */
export async function persistAuthStorageIfSupported(): Promise<void> {
  if (typeof navigator === 'undefined' || !navigator.storage?.persist) return;
  try {
    await navigator.storage.persist();
  } catch {
    // Best-effort only.
  }
}
